export default "__VITE_ASSET__DEDS$5hR__"